import React from 'react';
import { QuoteContent } from '../type';
import { QuoteView } from './Quote.view';
import { useQuoteState } from './Quote.state';

interface QuoteProps {
    onQuoteSelect: (content: QuoteContent) => void;
}

const Quote: React.FC<QuoteProps> = ({ onQuoteSelect }) => {
    const state = useQuoteState(onQuoteSelect);
    return <QuoteView {...state} />;
};

export default Quote;
